import React from 'react'
import List from '../../crud/list'
import menuItems from './menuItems'
import waitlistStatuses, { statusName } from '../../../fieldOptions/waitlistStatuses'

const columns = [
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Status', prop: 'status', format: statusName },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Updated', prop: 'updated_at', format: 'dateWithDay' }
]

const filters = [{
  name: 'Status',
  prop: 'filters.status',
  type: 'select',
  enabled: true,
  items: waitlistStatuses.map(status => {
    return {
      prop: status.value,
      title: status.name
    }
  })
}, {
  name: 'Filter by user',
  prop: 'filters.user_id',
  type: 'autocomplete',
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'name',
  enabled: true
}]

const defaults = {
  order: [{ column: 'id', direction: 'asc' }]
}

const SessionWaitlist = (props) => (
  <List
    title='Session Waitlist'
    apiPath='admin/session_waitlisters'
    fixedFilters={{ session_sale_id: props.params.sessionSaleId }}
    filters={filters}
    columns={columns}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
    hideCreate
  />
)

export default SessionWaitlist
